export default __webpack_public_path__ + "static/media/otter.a7a17b1f.svg";